import Web3 from 'web3';

export const getWeek = async (contract) => { 
  const weekNumber = await contract.methods.getWeek().call(); 
  return weekNumber;
};

export async function getWeekData(contract) { 
  const weekNumber = await getWeek(contract);
  const weekData = await contract.methods.weekData(weekNumber).call();
  const obj = {
    amount: weekData.amount,
    nbPlayers: weekData.nbPlayers,
  };  
  return obj;
};

export async function getHistory(contract) { 
  const weekNumber = await getWeek(contract);
  const obj = {};
  for (let i = weekNumber - 1; i >= Math.max(weekNumber - 5, 0); i--) {
    const weekData = await contract.methods.weekData(i).call();
    obj[i] = {
      "weekNumber" : i,
      "amount" : weekData.amount,
      "nbPlayers" : weekData.nbPlayers,
      "prizeClaimed" : weekData.prizeClaimed,
      "winner" : weekData.winner,
      "picker" : weekData.picker
    }
  }
  return obj;
};

export async function getOwner(contract) {
  let owner = await contract.methods.owner().call();
  return owner;
};

export const connectWallet = async () => {
  if (window.ethereum) {
    try {
      const addressArray = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const obj = {
        status: <div className="success">👍 Wallet successfully connected.</div>,
        address: addressArray[0],
      };
      return obj;
    } catch (err) {
      return {
        address: "",
        status: <div className="warning">😥 {err.message}</div>,
      };
    }
  } else {
    return {
      address: "",
      status: (
        <div className="warning">🦊 Metamask is not installed. You need to install it to play:&nbsp;
          <a target="_blank" rel="noreferrer" href="https://metamask.io/download">metamask.io</a>
        </div>
      ),
    };
  }
};

export async function getCurrentWalletConnected() {
  if (window.ethereum) {
    try {
      const addressArray = await window.ethereum.request({
        method: "eth_accounts",
      });
      if (addressArray.length > 0) {
        return {
          address: addressArray[0],
          status: "",
        };
      } else {
        return {
          address: "",
          status: <div className="warning">🦊 Connect to Metamask using the top right button.</div>,
        };
      }
    } catch (err) {
      return {
        address: "",
        status: <div className="warning">😥 {err.message}</div>,
      };
    }
  } else {
    return {
      address: "",
      status: (
        <div className="warning">🦊 Metamask is not installed. You need to install it to play:&nbsp;
          <a target="_blank" rel="noreferrer" href="https://metamask.io/download">metamask.io</a>
        </div>
      ),
    };
  }
};

export async function bet(contract, address, betAmount, explorerName, explorerUrl) {
  if (!window.ethereum || address === null || address === "") {
    return {
      status: <div className="warning">💡 Connect your Metamask wallet to be able to bet.</div>,
    };
  }

  //set up transaction parameters
  const transactionParameters = {
    to: contract._address, // Required except during contract publications.
    from: address, // must match user's active address.
    value: Web3.utils.toHex(betAmount),
    gas: Web3.utils.toHex(200000),
    data: contract.methods.bet().encodeABI(),
  };

  try {
    const txHash = await window.ethereum.request({
      method: "eth_sendTransaction",
      params: [transactionParameters],
    });

    return {
      status: (
        <div className="success">✅ You bet has been submitted to the network.
          <br />ℹ️ View the status of your transaction on&nbsp;
          <a target="_blank" rel="noreferrer" href={`${explorerUrl}${txHash}`}>{explorerName}!</a>
        </div>
      ),
    }
  } catch (error) {
    return {
      status: <div className="warning">😥 {error.message}</div>,
    }
  }
};


export async function pickWinner(contract, address, weekId, explorerName, explorerUrl) {
  if (!window.ethereum || address === null || address === "") {
    return {
      status: <div className="warning">💡 Connect your Metamask wallet to be able to pick a winner.</div>,
    };
  }
  //set up transaction parameters
  const transactionParameters = {
    to: contract._address, // Required except during contract publications.
    from: address, // must match user's active address.
    data: contract.methods.pickWinner(weekId).encodeABI(),
  };

  try {
    const txHash = await window.ethereum.request({
      method: "eth_sendTransaction",
      params: [transactionParameters],
    });

    return {
      status: (
        <div className="success">✅ You request has been submitted to the network.
          <br />ℹ️ View the status of your transaction on&nbsp;
          <a target="_blank" rel="noreferrer" href={`${explorerUrl}${txHash}`}>{explorerName}!</a>
        </div>
      ),
    }
  } catch (error) {
    return {
      status: <div className="warning">😥 {error.message}</div>,
    }
  }
};


export async function claimPrize(contract, address, weekId, explorerName, explorerUrl) {
  if (!window.ethereum || address === null || address === "") {
    return {
      status: <div className="warning">💡 Connect your Metamask wallet to be able to claim your Prize</div>,
    };
  }
  //set up transaction parameters
  const transactionParameters = {
    to: contract._address, // Required except during contract publications.
    from: address, // must match user's active address.
    data: contract.methods.claimPrize(weekId).encodeABI(),
  };

  try {
    const txHash = await window.ethereum.request({
      method: "eth_sendTransaction",
      params: [transactionParameters],
    });

    return {
      status: (
        <div className="success">✅ You request has been submitted to the network.
          <br />ℹ️ View the status of your transaction on&nbsp;
          <a target="_blank" rel="noreferrer" href={`${explorerUrl}${txHash}`}>{explorerName}!</a>
        </div>
      ),
    }
  } catch (error) {
    return {
      status: <div className="warning">😥 {error.message}</div>,
    }
  }
};

export async function claimRoyalty(contract, address, explorerName, explorerUrl) {
  if (!window.ethereum || address === null || address === "") {
    return {
      status: <div className="warning">💡 Connect your Metamask wallet to be able to claim your Royalty</div>,
    };
  }
  //set up transaction parameters
  const transactionParameters = {
    to: contract._address, // Required except during contract publications.
    from: address, // must match user's active address.
    data: contract.methods.claimRoyalty().encodeABI(),
  };

  try {
    const txHash = await window.ethereum.request({
      method: "eth_sendTransaction",
      params: [transactionParameters],
    });

    return {
      status: (
        <div className="success">✅ You request has been submitted to the network.
          <br />ℹ️ View the status of your transaction on&nbsp;
          <a target="_blank" rel="noreferrer" href={`${explorerUrl}${txHash}`}>{explorerName}!</a>
        </div>
      ),
    }
  } catch (error) {
    return {
      status: <div className="warning">😥 {error.message}</div>,
    }
  }
};


